export default __webpack_public_path__ + "static/media/advantages-principais-titulos-1.5dcfc54c.png";